"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const Text_1 = __importDefault(require("./Text"));
const CardHeader = ({ avatar, description, title }) => {
    return (react_1.default.createElement(react_native_1.View, { style: styles.header },
        avatar && react_1.default.createElement(react_native_1.Image, { style: styles.avatar, source: avatar, resizeMode: "contain" }),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(Text_1.default, { color: "primary", style: styles.title, children: title }),
            react_1.default.createElement(Text_1.default, { color: "description", children: description }))));
};
exports.default = CardHeader;
const styles = react_native_1.StyleSheet.create({
    header: {
        flexDirection: 'row',
        marginBottom: styles_1.getSpacing(),
    },
    avatar: {
        height: 45,
        width: 45,
        marginRight: styles_1.getSpacing(),
    },
    title: {
        fontWeight: 'bold',
    },
});
